import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { BrandLiveCancelReasonCode, cancelBrandLiveDeal } from '../../api/payment/brand-live.api';
import { LIVE_CANCEL_REASON_LABEL, cancelReasonWarning, validateReason } from '../../utils/brand-live';
import DialogComponent from '../dialog/dialog.component';

// Creator huỷ hợp tác quảng cáo livestream đang chạy: chọn lý do, ghi rõ, xác nhận.

const errorMessage = (err: unknown, fallback: string) =>
  (err as { response?: { data?: { message?: string } } })?.response?.data?.message || fallback;

const CODES: BrandLiveCancelReasonCode[] = ['BrandScandal', 'Other'];

const BrandLiveCancelDialog: React.FC<{
  dealId: string;
  businessName: string;
  onClose: () => void;
  onDone: () => void;
}> = ({ dealId, businessName, onClose, onDone }) => {
  const [code, setCode] = useState<BrandLiveCancelReasonCode | null>(null);
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const lock = useRef(false);
  const warning = code ? cancelReasonWarning(code) : null;

  const submit = async () => {
    if (lock.current) return;
    if (!code) {
      toast.error('Hãy chọn lý do huỷ.');
      return;
    }
    const invalid = validateReason(text);
    if (invalid) {
      toast.error(invalid);
      return;
    }
    lock.current = true;
    setSubmitting(true);
    try {
      await cancelBrandLiveDeal(dealId, code, text.trim());
      toast.success(
        code === 'BrandScandal'
          ? 'Đã dừng quảng cáo. Admin sẽ xem xét lý do của bạn.'
          : 'Đã dừng quảng cáo livestream.'
      );
      onDone();
    } catch (err) {
      toast.error(errorMessage(err, 'Không huỷ được hợp tác.'));
    } finally {
      lock.current = false;
      setSubmitting(false);
    }
  };

  return (
    <DialogComponent visible title="Huỷ hợp tác" onClose={() => !submitting && onClose()} hideOnClickOutside={false}>
      <div className="flex flex-col gap-3 p-4">
        <p className="ui-text text-[14px]">Dừng quảng cáo livestream của {businessName}?</p>
        <div className="flex flex-col gap-2">
          {CODES.map((c) => (
            <label key={c} className="ui-text flex items-center gap-2 text-[14px]">
              <input type="radio" name="live-cancel-reason" checked={code === c} disabled={submitting} onChange={() => setCode(c)} />
              {LIVE_CANCEL_REASON_LABEL[c]}
            </label>
          ))}
        </div>
        {warning && <p className="text-[13px] font-semibold text-red-500">{warning}</p>}
        <textarea
          className="ui-input min-h-[100px] w-full px-3 py-2 text-[14px]"
          placeholder="Ghi rõ lý do của bạn"
          value={text}
          maxLength={1000}
          onChange={(e) => setText(e.target.value)}
        />
        <div className="ui-muted text-right text-[12px]">{text.trim().length}/1000</div>
        <div className="flex justify-end gap-2">
          <button type="button" disabled={submitting} onClick={onClose} className="ui-text rounded-lg border ui-divider px-4 py-2 text-[14px]">
            Đóng
          </button>
          <button
            type="button"
            disabled={submitting}
            onClick={submit}
            className="rounded-lg bg-red-600 px-4 py-2 text-[14px] font-semibold text-white disabled:opacity-60"
          >
            Xác nhận huỷ
          </button>
        </div>
      </div>
    </DialogComponent>
  );
};

export default BrandLiveCancelDialog;
